import * as Yup from 'yup';

export const generateFormConfig = (variables = []) => {
  const initialValues = {
      comentarios: ''
  };
  const validationSchema = {
      comentarios: Yup.string().optional()
  };
  variables.forEach(variable => {
    initialValues[variable] = '';
  
    if (variable !== 'listaMedicamentos' && variable !== 'especialidadMedico') {
      validationSchema[variable] = Yup.string().optional(); 
    }
  });
  return { initialValues, validationSchema };
};

export const generateMedicationsHtml = (medications = [], comments = "") => {
  let html = "";

  if (medications && medications.length > 0) {
    html += `<ul style="list-style-type: none; padding-left: 0; margin: 0;">${medications
      .map(m => `<li style="margin-bottom: 10px;"><strong style="font-size: 1.1em;">- ${m.name || ""} (${m.dose || ""})</strong><br/><span style="font-size: 0.9em; color: #555; padding-left: 15px;">${m.instructions || ""}</span></li>`)
      .join("")}</ul>`;
  }

  if (comments && comments.trim() !== "") {
    html += `
      <div style="margin-top: 15px; padding-top: 10px; border-top: 1px dashed #ccc;">
        <strong style="font-size: 1em; text-decoration: underline;">Indicaciones Adicionales:</strong>
        <p style="margin-top: 5px; font-size: 0.95em; white-space: pre-wrap;">${comments}</p>
      </div>
    `;
  }

  return html || "Sin prescripciones.";
};

export const hydrateCraftTemplateClient = (templateContent, values) => {
  const tplObj = typeof templateContent === "string" ? JSON.parse(templateContent) : JSON.parse(JSON.stringify(templateContent));

  const globalSignatureUrl = values.signatureUrl || null;
  
  const EMPTY_VALUE_REPLACEMENT = 'N/A';
  
  const replaceVariables = (text) => {
    if (typeof text !== "string") return text;
    return text.replace(/{{(.*?)}}/g, (_, key) => {
      const k = key.trim();
      const v = values[k];
      if (v === undefined || v === null || v === "") {
        return EMPTY_VALUE_REPLACEMENT; 
      }
      if (typeof v === "object" && v !== null && "text" in v) {
        return `__HTML_OBJ__${JSON.stringify(v)}`;
      }
      if (typeof v === "string") {
        return v.replace(/"/g, '\\"');
      }
      return String(v);
    });
  };

  const hydrateNode = (node) => {
    if (!node) return;
    if (node.type?.resolvedName === 'Signature' && globalSignatureUrl) {
      node.props.signatureUrl = globalSignatureUrl; 
    }
    if (node.props) {
      for (const [propKey, propVal] of Object.entries(node.props)) {
        if (typeof propVal === "string") {
          const replaced = replaceVariables(propVal);
          const htmlMatch = replaced.match(/__HTML_OBJ__(\{.*\})/); 

          if (htmlMatch) {
            try {
              const fullString = replaced;
              const obj = JSON.parse(htmlMatch[1]);

              const htmlToInsert = obj.text ?? ""; 
                      
              node.props[propKey] = fullString.replace(htmlMatch[0], htmlToInsert);

              node.props.allowHtml = node.props.allowHtml || !!obj.allowHtml;
            } catch (e) {
              node.props[propKey] = replaced;
            }
          } else {
            node.props[propKey] = replaced;
          }
        }
      }
    }
    if (node.nodes && Array.isArray(node.nodes)) {
      node.nodes.forEach(childId => hydrateNode(tplObj[childId]));
    }
  };

  hydrateNode(tplObj.ROOT);
  return tplObj;
};

export const arrayBufferToBase64 = (buffer) => {
  const bytes = new Uint8Array(buffer);
  let binary = "";
  const chunkSize = 0x8000;
  for (let i = 0; i < bytes.length; i += chunkSize) {
    const chunk = bytes.subarray(i, i + chunkSize);
    binary += String.fromCharCode.apply(null, chunk);
  }
  return btoa(binary);
};